import { round } from "../util/view";

const formatSwells = (swellsForTime, units) => {
  const conversionFactor = units === "FT" ? 1 : 3.28;
  return swellsForTime.swells
    .filter((s) => s.height > 0) //remove 0 height swells
    .map(({ optimalScore, directionMin, ...s }) => s) //remove unwanted properties
    .map((s) => ({
      ...s,
      height: round(s.height * conversionFactor, 1), //convert to feet from meters if necessary
      direction: round(s.direction, 0),
    }));
};

export const getSwellsforStartTime = (surflineResult, startTime) => {
  const allSwells = surflineResult.data.data.wave;
  const hour = parseInt(startTime.slice(0, 2));
  const ndx = hour > 0 ? hour - 1 : 0;
  return formatSwells(
    allSwells[ndx],
    surflineResult.data.associated.units.waveHeight
  );
};

export const getTideForTime = (surflineResult, timestamp) => {
  const { tides } = surflineResult?.data;
  const hour = parseInt(timestamp.slice(0, 2));
  const minute = parseInt(timestamp.slice(3, 5));
  const ndx = minute > 30 ? hour + 1 : hour;
  const tidesWithoutMaxima = tides.filter((t) => t.type === "NORMAL");
  const closestTide = tidesWithoutMaxima[ndx];
  const height = parseFloat(closestTide.height.toFixed(1));
  const tide = {
    height: height,
    rising: isTideRising(closestTide.timestamp, tides),
  };
  return tide;
};

const isTideRising = (ts, tides) => {
  let currentlyRising = false;

  for (let i = 0; i < tides.length; i++) {
    let currentTide = tides[i];
    if (currentTide.timestamp < ts) {
      if (currentTide.type === "HIGH") {
        currentlyRising = false;
      } else if (currentTide.type === "LOW") {
        currentlyRising = true;
      }
    } else if (currentTide.timestamp > ts) {
      // console.log(`our ts is  ${currentlyRising ? "rising" : "falling"}`);
      return currentlyRising;
    }
  }
  return currentlyRising;
};

export const getTidesForSesh = (surflineResult, startTime, endTime) => {
  const startTide = getTideForTime(surflineResult, startTime);
  const endTide = getTideForTime(surflineResult, endTime);
  return [startTide, endTide];
};
